/*eslint-disable*/
import api from '../'

class SynonymsApi {
    // get: /synonyms-reading-en
    static getSynonymsByParams (params) {
        return api.axios.get('/synonyms-reading-en', { params })
            .then(response => response.data);
    }
}

export default SynonymsApi;
